import { api } from './client';
import type { Venue, VenueCategory } from '../types';
import type { OpeningHoursPeriod } from './places.api';

/** What went with the place. `days` are day numbers, ascending. */
export interface VenueRemoval { removedActivities: number; days: number[] }

export interface VenueDetails {
  photos:            string[];
  rating?:           number;
  userRatingsTotal?: number;
  priceLevel?:       number;
  openNow?:          boolean;
  openingHoursPeriods?: OpeningHoursPeriod[];
  phone?:            string;
  website?:          string;
  mapsUrl?:          string;
  address?:          string;
}

export const venuesApi = {
  list: (tripId: string, category?: VenueCategory) =>
    api.get<Venue[]>(`/trips/${tripId}/venues`, { params: category ? { category } : {} }).then(r => r.data),
  create: (tripId: string, data: Partial<Venue>) =>
    api.post<Venue>(`/trips/${tripId}/venues`, data).then(r => r.data),
  update: (tripId: string, venueId: string, data: Partial<Venue>) =>
    api.patch<Venue>(`/trips/${tripId}/venues/${venueId}`, data).then(r => r.data),
  /** Deleting a place takes its stops with it — the answer says how many. */
  delete: (tripId: string, venueId: string) =>
    api.delete<VenueRemoval>(`/trips/${tripId}/venues/${venueId}`).then(r => r.data),
  toggleVisited: (tripId: string, venueId: string, visited: boolean) =>
    api.patch<Venue>(`/trips/${tripId}/venues/${venueId}/visited`, { visited }).then(r => r.data),
  coords: (tripId: string) =>
    api.get<{ items: { id: string; lat: number; lng: number }[] }>(
      `/trips/${tripId}/venues/coords`,
    ).then(r => r.data.items),
  getDetails: (tripId: string, venueId: string) =>
    api.get<{ details: VenueDetails | null }>(`/trips/${tripId}/venues/${venueId}/details`).then(r => r.data.details),
};
